<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M27.724,45.336l6.342,6.342a.783.783,0,0,0,1.108,0l.74-.74a.783.783,0,0,0,0-1.106l-5.026-5.05,5.026-5.05a.783.783,0,0,0,0-1.106l-.74-.74a.783.783,0,0,0-1.108,0l-6.342,6.342A.783.783,0,0,0,27.724,45.336Z" transform="translate(-21.49 -32.707)" class="fill-current stroke-current"/>
  </svg>
</template>
